<template>
  <div class="form">
    <indexTitle title1="投资计算器" title2="开这样一家店需要多少钱？" color="#955225"></indexTitle>
    <Input
      prefix="ios-contact"
      placeholder="请输入你的姓名"
      size="large"
      v-model="username"
      style="width: 100%;margin-bottom:10px;"
    />
    <Input
      prefix="ios-call"
      placeholder="请输入你的电话"
      size="large"
      v-model="mobile"
      type="tel"
      style="width: 100%;margin-bottom:10px;"
    />
    <Input
      prefix="ios-navigate"
      placeholder="请输入你的城市所在区域"
      size="large"
      v-model="where"
      style="width: 100%;margin-bottom:10px;"
    />
    <Input
      prefix="md-calculator"
      placeholder="请输入店铺面积（平方米）"
      size="large"
      v-model="area"
      type="number"
      style="width: 100%;margin-bottom:10px;"
    />
    <Button
      type="warning"
      size="large"
      :style="{ background: bag, color: color, height: '41px' }"
      :loading="loading"
      v-on:click="send"
      long
      >{{ buttonWords }}</Button
    >
    <div style="width:100%;height:5px;"></div>
    <h4>
      <b style="color:red">#</b>今天已有 <b style="color:red">258</b>位访客获取了投资预算
      <b style="color:red">#</b>
    </h4>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      username: '',
      mobile: '',
      where: '',
      area: '',
      loading: false,
      buttonWords: this.words,
      radio2: '西点',
    };
  },
  components: {
    indexTitle: () => import('@/components/common/indexTitle'),
  },
  props: {
    color: {
      type: String,
      default: '#fff',
    },
    bag: {
      type: String,
      default: '#955225',
    },
    words: {
      type: String,
      default: '立即获取投资预算',
    },
  },
  methods: {
    send() {
      console.log(document.referrer);
      this.buttonWords = '';
      this.loading = true;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      console.log(this.$route.path);
      setTimeout(() => {
        this.loading = false;
        this.buttonWords = '点击报名';
      }, 1500);
      if (this.username == '' || this.mobile == '') {
        Toast.fail('请完整填写表单');
        return false;
      } else if (!valid_rule.test(this.mobile)) {
        Toast.fail('手机号码错误');
        return false;
      } else {
        this.$axios
          .get('http://api.cdomick.com/index.php/api/form', {
            params: {
              name: this.username,
              mobile: this.mobile,
              c_like: this.radio2,
              laiyuan: window.location.href,
              first: document.referrer,
            },
          })
          .then(function(response) {
            console.log(response);
            if (response.data.code == 1) {
              Toast.success(response.data.msg);
              window._agl && window._agl.push(['track', ['success', { t: 3 }]]);
              location.reload();
            } else {
              Toast.success('提交成功');
              window._agl && window._agl.push(['track', ['success', { t: 3 }]]);
              location.reload();
            }
          })
          .catch(function(error) {
            console.log(error);
            Toast.success('成功');
            this.loading = false;
            this.buttonWords = '点击报名';
            window._agl && window._agl.push(['track', ['success', { t: 3 }]]);
            location.reload();
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 100%;
  text-align: center;
  padding: 10px;
}
/deep/ .ivu-input:hover {
  color: #955225;
  border: 1px solid #955225;
}
/deep/ .ivu-radio-inner:after {
  background: #955225;
}
/deep/ .ivu-radio-checked:hover .ivu-radio-inner {
  border-color: #955225;
}
/deep/.ivu-radio-checked .ivu-radio-inner {
  border-color: #955225;
}
/deep/ .ivu-input-wrapper-large .ivu-input-prefix i,
.ivu-input-wrapper-large .ivu-input-suffix i {
  line-height: 45px;
}
/deep/ .ivu-input-large {
  height: 45px;
}
/deep/ .ivu-input-wrapper-large .ivu-input-prefix i,
.ivu-input-wrapper-large .ivu-input-suffix i {
  color: #955225;
}
/deep/ .ivu-btn-warning {
  border-color: #fff;
}
</style>
